(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(9707);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ StyledTextBlock; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2125);
/* harmony import */ var _layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6797);
/* harmony import */ var _styles_textLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(308);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: ",
        ";\n\n  > * {\n    margin: 0 0 1rem 0;\n    max-width: 45rem;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1 {\n    ",
        "\n    font-size: ",
        ";\n  }\n  \n  h2 {\n    ",
        "\n    font-size: ",
        ";\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n\n  h3 {\n    ",
        "\n    font-size: ",
        ";\n  }\n\n  a {\n    color: inherit;\n    text-decoration-color: ",
        ";\n    text-underline-offset: 3px;\n    text-decoration-thickness: 1px;\n  }\n\n  > a,\n  p a:only-child {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function TextBlock(param) {
    var _color = param.color, color = _color === void 0 ? "grey2" : _color, textStyle = param.textStyle, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* .ShiftAlign */ .Ow, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledTextBlock, {
                $color: color,
                $size: textStyle,
                dangerouslySetInnerHTML: {
                    __html: children
                }
            })
        })
    });
}
var StyledTextBlock = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ed2c3774-0"
})(_templateObject(), function(p) {
    return p.theme.getColor(p.$color);
}, function(p) {
    return p.$size === "large" ? p.theme.typo.sizes.large : p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.normal;
}, function(p) {
    return p.theme.colors.highlight;
}, _styles_textLink__WEBPACK_IMPORTED_MODULE_3__/* .soloTextLink */ .RY);
/* harmony default export */ __webpack_exports__["Z"] = (TextBlock);


/***/ }),

/***/ 8375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(2125);
/* harmony import */ var _layout_Container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6797);
/* harmony import */ var _CmsTextBlock__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1864);
/* harmony import */ var _ImagesBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9948);
/* harmony import */ var _Video__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1778);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(570);
/* harmony import */ var _Link__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5741);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  --para-margin: 1rem;\n  --button-margin: 3rem;\n  --media-margin: 4rem;\n\n  .hod-text-block {\n    &:not( :first-child ) {\n      margin-top: var( --para-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --para-margin );\n    }\n  }\n  \n  .hod-text-block--large {\n    &:not( :first-child ) {\n      margin-top: var( --button-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --button-margin );\n    }\n  }\n  \n  .hod-button-block {\n    &:not( :first-child ) {\n      margin-top: var( --button-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --button-margin );\n    }\n  }\n\n  .hod-images-block,\n  .hod-video-block {\n    &:not( :first-child ) {\n      margin-top: var( --media-margin );\n    }\n    \n    &:not( :last-child ) {\n      margin-bottom: var( --media-margin );\n    }\n  }\n\n  .hod-video-block {\n    > div {\n      position: relative;\n      overflow: hidden;\n      width: 100%;\n      padding-bottom: 56.25%;\n\n      > iframe {\n        left: 0;\n        top: 0;\n        height: 100%;\n        width: 100%;\n        position: absolute;\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin: var( --grid-parent-gutter );\n\n  > * {\n    box-sizing: border-box;\n    margin: var( --grid-child-gutter );\n    flex: 1 0 calc( 33.333% - 2rem );\n    min-width: 200px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}








function ContentBuilder(param) {
    var content = param.content, _light = param.light, light = _light === void 0 ? false : _light;
    var color = light ? "grey9" : "grey2";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledContentStack, {
        children: content.map(function(contentBlock) {
            if (contentBlock.typeHandle === "text") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "hod-text-block hod-text-block--".concat(contentBlock.style),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_CmsTextBlock__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        color: color,
                        textStyle: contentBlock.style || "normal",
                        children: contentBlock.text
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "images") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-images-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledImagesBlock, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_ImagesBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            images: contentBlock.images,
                            layout: "auto"
                        })
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "video") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-video-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Video__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            contentItem: contentBlock
                        })
                    })
                }, contentBlock.id);
            }
            if (contentBlock.typeHandle === "button") {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                    className: "hod-button-block",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_Container__WEBPACK_IMPORTED_MODULE_2__/* .ShiftAlign */ .Ow, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            $inline: true,
                            $color: color,
                            $textColor: light ? "grey2" : "grey9",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Link__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
                                href: contentBlock.buttonLink,
                                children: contentBlock.buttonText
                            })
                        })
                    })
                }, contentBlock.id);
            }
            return null;
        })
    });
}
var StyledContentStack = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-926f21a5-0"
})(_templateObject());
var StyledImagesBlock = styled_components__WEBPACK_IMPORTED_MODULE_8__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-926f21a5-1"
})(_templateObject1());
/* harmony default export */ __webpack_exports__["Z"] = (ContentBuilder);


/***/ }),

/***/ 9948:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2125);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7753);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    > div {\n      width: 100%;\n      display: flex;\n      align-items: center;\n      \n      > div {\n        position: relative;\n        width: 100%;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        padding-bottom: 100%;\n      }\n    }\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    top: 0.6rem;\n    left: 0.6rem;\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n    bottom: 0.6rem;\n    right: 0.6rem;\n  "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  font-size: ",
        ";\n  color: ",
        ";\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-bottom: 0;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}



function ImagesBlock(param) {
    var images = param.images, _layout = param.layout, layout = _layout === void 0 ? "fill" : _layout, _objectFit = param.objectFit, objectFit = _objectFit === void 0 ? "cover" : _objectFit;
    var imgLayout = layout === "auto" ? images.length > 1 ? "fill" : "intrinsic" : layout;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: images.map(function(image) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(StyledImage, {
                $layout: imgLayout,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                            children: [
                                imgLayout === "fill" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: image.url,
                                    alt: image.altText || image.title,
                                    layout: "fill",
                                    objectFit: objectFit,
                                    dateModified: image.dateModified
                                }),
                                imgLayout !== "fill" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Image__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    src: image.url,
                                    alt: image.altText || image.title,
                                    width: image.width,
                                    height: image.height,
                                    layout: imgLayout,
                                    objectFit: objectFit,
                                    dateModified: image.dateModified
                                }),
                                image.attribution && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledAttribution, {
                                    $position: "bottom",
                                    children: image.attribution
                                })
                            ]
                        })
                    }),
                    image.altText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledDescription, {
                        children: image.altText
                    })
                ]
            }, image.id);
        })
    });
}
var StyledImage = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-137ec2bc-0"
})(_templateObject1(), function(p) {
    return p.$layout === "fill" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject());
});
var StyledAttribution = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].span.withConfig */ .ZP.span.withConfig({
    componentId: "sc-137ec2bc-1"
})(_templateObject4(), function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.grey9;
}, function(p) {
    return p.$position === "top" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject2());
}, function(p) {
    return p.$position === "bottom" && (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* .css */ .iv)(_templateObject3());
});
var StyledDescription = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].p.withConfig */ .ZP.p.withConfig({
    componentId: "sc-137ec2bc-2"
})(_templateObject5(), function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.grey8;
});
/* harmony default export */ __webpack_exports__["Z"] = (ImagesBlock);


/***/ }),

/***/ 6753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_LetsDiscusCTABlock; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/Button.tsx
var Button = __webpack_require__(570);
// EXTERNAL MODULE: ./styles/textLink.ts
var textLink = __webpack_require__(308);
;// CONCATENATED MODULE: ./components/CTABlock.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n\n  &:before {\n    content: '';\n    position: absolute;\n    top: 55.03%;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: ",
        ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    background: linear-gradient(\n      180deg, \n      rgba(144, 62, 255, 0) 4.25%, \n      rgba(144, 62, 255, 0.4) 20.66%, \n      rgba(144, 62, 255, 0.8) 34.72%, \n      #903EFF 53.47%, \n      rgba(144, 62, 255, 0.8) 71.18%, \n      rgba(144, 62, 255, 0.4) 87.85%, \n      rgba(144, 62, 255, 0) 100%\n    );\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-align: center;\n  color: ",
        ";\n\n  > * {\n    position: relative;\n    z-index: 1;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    ",
        "\n    font-size: ",
        ";\n  }\n\n  ",
        " {\n    display: flex;\n    justify-content: center;\n\n    button,\n    a {\n      ",
        ";\n      font-size: ",
        ";\n      color: ",
        ";\n\n      &:hover {\n        color: ",
        ";\n      }\n    }\n  }\n  \n  > div > a {\n    ",
        "\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}






function CTABlock(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTABlockWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.ZP, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledCTABlock, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                    $top: 10,
                    $between: 2,
                    $bottom: 10,
                    children: children
                })
            })
        })
    });
}
var StyledCTABlockWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a575ee6-0"
})(_templateObject(), function(p) {
    return p.theme.colors.grey9;
});
var StyledCTABlock = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-4a575ee6-1"
})(_templateObject1(), function(p) {
    return p.theme.colors.grey9;
}, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.bigCTA;
}, Button/* default */.Z, function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.highlight;
}, function(p) {
    return p.theme.colors.grey9;
}, textLink/* soloTextLink */.RY);
/* harmony default export */ var components_CTABlock = (CTABlock);

// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
;// CONCATENATED MODULE: ./components/LetsDiscusCTABlock.tsx





function LetsDiscusCTABlock() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_CTABlock, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "Has this project made you think?",
                    defaultMessage: "Has this project made you think?",
                    id: "Q6KiQZ"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                $rounded: true,
                $color: "grey9",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                    href: "/lets-discuss",
                    children: "Let\u2019s discuss"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.ZP, {
                href: "/lets-explore",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "More information",
                    defaultMessage: "More information",
                    id: "aGuUOT"
                })
            })
        ]
    });
}
/* harmony default export */ var components_LetsDiscusCTABlock = (LetsDiscusCTABlock);


/***/ }),

/***/ 1778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

function Video(param) {
    var contentItem = param.contentItem;
    var ref = getVideoParams(contentItem), videoType = ref.videoType, videoUrl = ref.videoUrl;
    if (videoType === "file") {
        return(// eslint-disable-next-line jsx-a11y/media-has-caption
        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
            controls: true,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                    src: videoUrl
                }),
                "Sorry, your browser doesn\u2019t support embedded videos."
            ]
        }));
    }
    if (videoType === "embed") {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            width: "853",
            height: "480",
            src: videoUrl,
            frameBorder: "0",
            allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
            allowFullScreen: true,
            title: "Embedded youtube"
        });
    }
    return null;
}
function getVideoParams(block) {
    var ref, ref1;
    if ((ref = block.videoFile) === null || ref === void 0 ? void 0 : (ref1 = ref[0]) === null || ref1 === void 0 ? void 0 : ref1.url) {
        var ref2, ref3;
        return {
            videoType: "file",
            videoUrl: (ref2 = block.videoFile) === null || ref2 === void 0 ? void 0 : (ref3 = ref2[0]) === null || ref3 === void 0 ? void 0 : ref3.url
        };
    }
    if (block.videoUrl) {
        return {
            videoType: "embed",
            videoUrl: getVideoUrl(block.videoUrl)
        };
    }
    return {
        videoType: null,
        videoUrl: null
    };
}
function getVideoUrl(url) {
    var ref, ref1;
    var youTubeRegExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    var youTubeMatch = url.match(youTubeRegExp);
    if (youTubeMatch && ((ref = youTubeMatch[2]) === null || ref === void 0 ? void 0 : ref.length) === 11) {
        return "//www.youtube-nocookie.com/embed/".concat(youTubeMatch[2]);
    }
    var vimeoRegExp = /(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:[a-zA-Z0-9_-]+)?/i;
    var vimeoMatch = url.match(vimeoRegExp);
    if (vimeoMatch && ((ref1 = vimeoMatch[1]) === null || ref1 === void 0 ? void 0 : ref1.length) > 1) {
        return "//player.vimeo.com/video/".concat(vimeoMatch[1], "?dnt=1");
    }
    return null;
}
/* harmony default export */ __webpack_exports__["Z"] = (Video);


/***/ }),

/***/ 9707:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(1163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/js-cookie/dist/js.cookie.mjs
var js_cookie = __webpack_require__(1955);
// EXTERNAL MODULE: ./components/layout/Background.tsx
var Background = __webpack_require__(7940);
// EXTERNAL MODULE: ./components/layout/Stack.tsx
var Stack = __webpack_require__(4970);
// EXTERNAL MODULE: ./components/AppChrome.tsx + 7 modules
var AppChrome = __webpack_require__(7504);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(2125);
;// CONCATENATED MODULE: ./hooks/useWindowResize.tsx

var useWindowResize = function() {
    var handler = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], onLoad = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    (0,react.useEffect)(function() {
        if (true) {
            window.addEventListener("resize", handler);
            if (onLoad) {
                handler();
            }
            return function() {
                return window.removeEventListener("resize", handler);
            };
        }
    }, deps);
};
/* harmony default export */ var hooks_useWindowResize = (useWindowResize);

// EXTERNAL MODULE: ./components/Image.tsx
var Image = __webpack_require__(7753);
;// CONCATENATED MODULE: ./components/icons/Chevron.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotate( 180deg );\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotate( 270deg );\n    "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      transform: rotate( 90deg );\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    display: block;\n\n    ",
        "\n    \n    ",
        "\n    \n    ",
        "\n\n    path {\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


function Chevron(param) {
    var _color = param.color, color = _color === void 0 ? "white" : _color, _left = param.left, left = _left === void 0 ? false : _left, _right = param.right, right = _right === void 0 ? true : _right, _up = param.up, up = _up === void 0 ? false : _up, _down = param.down, down = _down === void 0 ? false : _down;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledChevron, {
        $left: left,
        $right: right,
        $up: up,
        $down: down,
        $color: color,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
            width: "28",
            height: "48",
            viewBox: "0 0 28 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M1.30176 47L26.4538 24.748C26.5595 24.6542 26.6441 24.539 26.7021 24.4101C26.7601 24.2811 26.7901 24.1414 26.7901 24C26.7901 23.8586 26.7601 23.7189 26.7021 23.5899C26.6441 23.461 26.5595 23.3458 26.4538 23.252L1.30176 1",
                stroke: "black",
                strokeWidth: "2",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    });
}
var StyledChevron = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-1edfed25-0"
})(_templateObject3(), function(p) {
    return p.$left && (0,styled_components_browser_esm/* css */.iv)(_templateObject());
}, function(p) {
    return p.$up && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
}, function(p) {
    return p.$down && (0,styled_components_browser_esm/* css */.iv)(_templateObject2());
}, function(p) {
    return p.theme.getColor(p.$color);
});
/* harmony default export */ var icons_Chevron = (Chevron);

;// CONCATENATED MODULE: ./components/Splash.tsx

function Splash_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 100vh;\n\n  "
    ]);
    Splash_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Splash_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  height: 100vh;\n\n  video {\n    display: block;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"
    ]);
    Splash_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Splash_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 5vh;\n  left: 50%;\n  transform: translateX( -50% );\n  width: 50px;\n  height: 50px;\n  border-radius: 100%;\n  background: ",
        ";\n  cursor: pointer;\n\n  svg {\n    margin: 0.2rem auto 0;\n    width: 32%;\n  }\n"
    ]);
    Splash_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function Splash(param) {
    var _image = param.image, image = _image === void 0 ? null : _image, _video = param.video, video = _video === void 0 ? null : _video, _scrollTo = param.scrollTo, scrollTo = _scrollTo === void 0 ? null : _scrollTo;
    var playerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), isPortrait = ref[0], setIsPortrait = ref[1];
    var videos = video && getVideos(video, isPortrait);
    hooks_useWindowResize(function() {
        if (!isPortrait && window.innerWidth / window.innerHeight < 1) {
            setIsPortrait(true);
        } else if (isPortrait && window.innerWidth / window.innerHeight >= 1) {
            setIsPortrait(false);
        }
    }, [], true);
    var onScrollBtnClick = function(e) {
        e.preventDefault();
        if (scrollTo === null || scrollTo === void 0 ? void 0 : scrollTo.current) {
            scrollTo.current.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        }
    };
    (0,react.useEffect)(function() {
        var player = playerRef.current;
        var onVideoEnd = function() {
            if ((scrollTo === null || scrollTo === void 0 ? void 0 : scrollTo.current) && window.scrollY === 0) {
                scrollTo.current.scrollIntoView({
                    behavior: "smooth",
                    block: "start"
                });
            }
        };
        player === null || player === void 0 ? void 0 : player.addEventListener("ended", onVideoEnd);
        return function() {
            player === null || player === void 0 ? void 0 : player.addEventListener("ended", onVideoEnd);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSplash, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledImageWrapper, {
                children: [
                    image && /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: image.url,
                        alt: "",
                        layout: "fill",
                        objectFit: "cover"
                    }),
                    video && /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                        ref: playerRef,
                        autoPlay: true,
                        muted: true,
                        playsInline: true,
                        children: videos.map(function(param) {
                            var type = param.type, src = param.src;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                src: src,
                                type: type
                            }, type);
                        })
                    }, JSON.stringify(videos))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledScrollBtn, {
                onClick: onScrollBtnClick,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_Chevron, {
                    color: "black",
                    down: true
                })
            })
        ]
    });
}
var getVideos = function(videos, isPortrait) {
    if (isPortrait) {
        var vids = videos.filter(function(v) {
            return v.portrait;
        });
        if (vids.length) {
            return videos.filter(function(v) {
                return v.portrait;
            });
        }
    }
    var vids1 = videos.filter(function(v) {
        return !v.portrait;
    });
    if (vids1.length) {
        return videos.filter(function(v) {
            return !v.portrait;
        });
    }
    return videos;
};
var StyledSplash = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-95fcfab9-0"
})(Splash_templateObject());
var StyledImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-95fcfab9-1"
})(Splash_templateObject1());
var StyledScrollBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-95fcfab9-2"
})(Splash_templateObject2(), function(p) {
    return p.theme.colors.highlight;
});
/* harmony default export */ var components_Splash = (Splash);

// EXTERNAL MODULE: ./components/Hero.tsx
var Hero = __webpack_require__(8634);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(4012);
// EXTERNAL MODULE: ./components/layout/Container.tsx
var Container = __webpack_require__(6797);
// EXTERNAL MODULE: ./components/Link.tsx
var Link = __webpack_require__(5741);
;// CONCATENATED MODULE: ./components/icons/ArrowIcon.tsx

function ArrowIcon_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  svg {\n    display: block;\n    \n    path {\n      stroke: ",
        ";\n    }\n  }\n"
    ]);
    ArrowIcon_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


function ArrowIcon(param) {
    var _color = param.color, color = _color === void 0 ? "grey1" : _color;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrowIcon, {
        $color: color,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "22",
            height: "20",
            viewBox: "0 0 22 20",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M10.7517 0.959473L19.772 9.97977L10.7517 19.0001",
                    stroke: "#0F0F0F",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M19.4924 10.0358L-5.38422e-08 10.0358",
                    stroke: "#0F0F0F",
                    strokeWidth: "2"
                })
            ]
        })
    });
}
var StyledArrowIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-7e999425-0"
})(ArrowIcon_templateObject(), function(p) {
    return p.theme.getColor(p.$color);
});
/* harmony default export */ var icons_ArrowIcon = (ArrowIcon);

;// CONCATENATED MODULE: ./components/TheSites.tsx

function TheSites_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 0;\n  margin-bottom: 2rem;\n  ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    TheSites_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TheSites_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  padding-bottom: 100%;\n\n  img {\n    opacity: 0.7;\n    transition: opacity .3s ease-out;\n  }\n"
    ]);
    TheSites_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TheSites_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  bottom: 1rem;\n  right: 1rem;\n  width: 44px;\n  height: 44px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: ",
        ";\n"
    ]);
    TheSites_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TheSites_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  top: 1rem;\n  left: 1rem;\n  font-size: ",
        ";\n  color: ",
        ";\n"
    ]);
    TheSites_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    top: 1rem;\n    left: 1rem;\n  "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    bottom: 1rem;\n    right: 1rem;\n  "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  font-size: ",
        ";\n  color: ",
        ";\n\n  ",
        "\n  \n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 1rem;\n  \n  h3 {\n    margin: 0;\n    ",
        "\n    font-size: ",
        ";\n    color: ",
        ";\n    transition: color .3s ease-out;\n\n    span {\n      display: block;\n      ",
        "\n    }\n  }\n\n  p {\n    margin-top: 1rem;\n    font-size: ",
        ";\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-wrap: wrap;\n  margin: var( --grid-parent-gutter );\n\n  > * {\n    box-sizing: border-box;\n    margin: var( --grid-child-gutter );\n    flex: 1 0 calc( 33.333% - 2rem );\n    min-width: 250px;\n  }\n\n  > a,\n  > div {\n    position: relative;\n    display: block;\n    color: inherit;\n  }\n\n  > a {\n    text-decoration: none;\n\n    &:hover {\n      ",
        " img {\n        opacity: 1;\n      }\n\n      ",
        " h3 {\n        color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}







function TheSites(param) {
    var sites = param.sites, _priority = param.priority, priority = _priority === void 0 ? false : _priority;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledHeading, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                    description: "The Artworks",
                    defaultMessage: "The Artworks",
                    id: "XT/4YO"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTheSites, {
                children: sites.map(function(site) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Link/* ConditionalLink */.MT, {
                        Component: "div",
                        href: site.artworkUrl,
                        passHref: true,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSiteImage, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                        src: site.siteImage[0].url,
                                        alt: site.title,
                                        layout: "fill",
                                        objectFit: "cover",
                                        priority: priority
                                    }),
                                    site.artworkUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledArrow, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_ArrowIcon, {
                                            color: "grey1"
                                        })
                                    }),
                                    site.artworkTag && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledTag, {
                                        children: site.artworkTag
                                    }),
                                    site.siteImage[0].attribution && /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledAttribution, {
                                        $position: site.artworkTag ? "bottom" : "top",
                                        children: site.siteImage[0].attribution
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(StyledSiteInfo, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                        children: [
                                            site.artworkTitle,
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: site.artistName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: site.title
                                    })
                                ]
                            })
                        ]
                    }, site.id);
                })
            })
        ]
    });
}
var StyledHeading = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-d66020d0-0"
})(TheSites_templateObject(), function(p) {
    return p.theme.typo.neueHaas;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.colors.grey9;
});
var StyledSiteImage = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d66020d0-1"
})(TheSites_templateObject1());
var StyledArrow = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d66020d0-2"
})(TheSites_templateObject2(), function(p) {
    return p.theme.colors.grey9;
});
var StyledTag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d66020d0-3"
})(TheSites_templateObject3(), function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.grey9;
});
var StyledAttribution = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-d66020d0-4"
})(_templateObject6(), function(p) {
    return p.theme.typo.sizes.dropped;
}, function(p) {
    return p.theme.colors.grey9;
}, function(p) {
    return p.$position === "top" && (0,styled_components_browser_esm/* css */.iv)(_templateObject4());
}, function(p) {
    return p.$position === "bottom" && (0,styled_components_browser_esm/* css */.iv)(_templateObject5());
});
var StyledSiteInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d66020d0-5"
})(_templateObject7(), function(p) {
    return p.theme.typo.neueHaasBold;
}, function(p) {
    return p.theme.typo.sizes.large;
}, function(p) {
    return p.theme.colors.grey8;
}, function(p) {
    return p.theme.typo.neueHaas;
}, function(p) {
    return p.theme.typo.sizes.medium;
}, function(p) {
    return p.theme.colors.grey7;
});
var StyledTheSites = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-d66020d0-6"
})(_templateObject8(), StyledSiteImage, StyledSiteInfo, function(p) {
    return p.theme.colors.grey9;
});
/* harmony default export */ var components_TheSites = (TheSites);

// EXTERNAL MODULE: ./components/ContentBuilder.tsx
var ContentBuilder = __webpack_require__(8375);
// EXTERNAL MODULE: ./components/LetsDiscusCTABlock.tsx + 1 modules
var LetsDiscusCTABlock = __webpack_require__(6753);
// EXTERNAL MODULE: ./components/MetaTags.tsx
var MetaTags = __webpack_require__(8716);
;// CONCATENATED MODULE: ./pages/index.tsx













function Home(param) {
    var homepage = param.entry, sites = param.sites;
    var heroRef = (0,react.useRef)(null);
    var heroContent = homepage.hero[0];
    (0,react.useEffect)(function() {
        if (js_cookie/* default.get */.Z.get("hod-viewed-splash")) {
            heroRef.current.scrollIntoView({
                block: "start"
            });
        }
        var setSplashViewedCookie = function() {
            js_cookie/* default.set */.Z.set("hod-viewed-splash", true);
        };
        router_default().events.on("routeChangeStart", setSplashViewedCookie);
        window.addEventListener("beforeunload", setSplashViewedCookie);
        return function() {
            router_default().events.off("routeChangeStart", setSplashViewedCookie);
            window.removeEventListener("beforeunload", setSplashViewedCookie);
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(AppChrome/* default */.Z, {
        pageHasSplash: true,
        darkPage: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTags/* default */.Z, {
                url: "/",
                title: null
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Splash, {
                video: [
                    {
                        portrait: true,
                        type: "video/mp4",
                        src: "https://cdn.housesofdarkness.eu/videos/HOD_Trailer_Mobile.mp4"
                    },
                    {
                        portrait: false,
                        type: "video/mp4",
                        src: "https://cdn.housesofdarkness.eu/videos/HOD_Trailer_V5.mp4"
                    }, 
                ],
                scrollTo: heroRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Background/* default */.Z, {
                $gradient: {
                    angle: 180,
                    steps: {
                        11: "grey2",
                        53: "grey3",
                        100: "grey5"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* default */.Z, {
                        elementRef: heroRef,
                        title: heroContent.heroTitle,
                        subheading: heroContent.subtitle,
                        html: heroContent.body,
                        light: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $top: "3rem",
                        $bottom: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_TheSites, {
                            sites: sites,
                            priority: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        $top: "3rem",
                        $bottom: "3rem",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ContentBuilder/* default */.Z, {
                            content: homepage.contentBuilder,
                            light: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LetsDiscusCTABlock/* default */.Z, {})
                ]
            })
        ]
    });
}
var __N_SSP = true;
/* harmony default export */ var pages = (Home);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);